import { AssetsFileSchema, BaseLoaderUtil } from '../../types/asset/asset.types.ts';

import { getSentryUtil } from '../monitoring/sentry.util.ts';

import { AssetFilesUtil, getAssetFilesUtil } from './asset-files.util.ts';
import { getCharactersUtil } from './characters.util.ts';
import { getLessonsUtil } from './lessons.util.ts';
import { getLettersUtil } from './letters.util.ts';
import { getScriptsUtil } from './scripts.util.ts';
import { getWordsUtil } from './words.util.ts';
import { getWritingPathsUtil } from './writing-paths.util.ts';

export class AssetUtil {
  private static _instance: AssetUtil;
  private assetFilesUtil: AssetFilesUtil = getAssetFilesUtil();
  private readonly loaders: BaseLoaderUtil[] = [
    getCharactersUtil(),
    getLessonsUtil(),
    getLettersUtil(),
    getScriptsUtil(),
    getWordsUtil(),
    getWritingPathsUtil(),
  ];

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  public static get instance(): AssetUtil {
    if (!AssetUtil._instance) {
      AssetUtil._instance = new AssetUtil();
    }
    return AssetUtil._instance;
  }

  public async loadAllData(env?: string): Promise<void> {
    try {
      this.assetFilesUtil.setEnvironment(env);
      const data = await this.assetFilesUtil.loadAssetsFile();
      const assets = AssetsFileSchema.parse(data);

      await Promise.all(this.loaders.map((loader) => loader.load(assets)));
    } catch (error) {
      getSentryUtil().trackError(error as Error, {
        in: 'AssetUtil.loadAllData',
      });
      throw error;
    }
  }
}

// Export a singleton instance
export const getAssetUtil = (): AssetUtil => AssetUtil.instance;
